import getWebviewUrl from "@/utils/webview/getWebviewUrl";

const useWebview = () => {
  const isWebview = () => {
    if (typeof window !== "undefined") {
      return window.location.href.includes("webview");
    }
    return false;
  };

  const getUrl = (url?: string): string | undefined => {
    if (!url) return url;
    return isWebview() ? getWebviewUrl(url) : url;
  };

  return { isWebview, getUrl };
};

export default useWebview;
